// extracted by mini-css-extract-plugin
export default {"permission-item":"_4lrmv9","permissionItem":"_4lrmv9"};